<app-hero></app-hero>
<app-brand-list></app-brand-list>
<app-large-content></app-large-content>
<app-promotions></app-promotions>
<app-testimonials></app-testimonials>
<app-faq-section></app-faq-section>
<app-responsible-gambling-section></app-responsible-gambling-section>

